import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Spring/LengthAndHeight/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'LengthAndHeight',
  field: 'Measurement',
  weeks: [9, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/LengthAndHeight/1CompareLengthsAndHeights" */ './1CompareLengthsAndHeights'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/LengthAndHeight/2MeasureLengthUsingObjects" */ './2MeasureLengthUsingObjects'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Spring/LengthAndHeight/3MeasureLengthInCentimetres" */ './3MeasureLengthInCentimetres'
        )
    })
  ]
});
export default Block;
